import PropTypes from 'prop-types';
import { generic } from 'apis';

class QubFile {
    constructor({ id, name, extesion, type, file, position, fileGuid, fileObject }) {
        this.id = id;
        this.name = name;
        this.extension = extesion;
        this.type = type;
        this.file = file;
        this.position = position;
        this.fileGuid = fileGuid;
        this.fileObject = fileObject;
    }

    base64ToFile(base64String, fileName) {
        // Split the base64 string in data and contentType
        const [base64Header, base64Data] = base64String.split(',');
        const mimeType = base64Header.match(/:(.*?);/)[1];

        // Decode the base64 string
        const byteCharacters = atob(base64Data);

        // Create an array of 8-bit unsigned integers
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        // Create a `Uint8Array` from the byte numbers array
        const byteArray = new Uint8Array(byteNumbers);

        // Create a `Blob` from the `Uint8Array`
        const blob = new Blob([byteArray], { type: mimeType });

        // Create a `File` from the `Blob`
        const file = new File([blob], fileName, { type: mimeType });

        return file;
    }

    async downloadFile() {
        try {
            if (this.id && !this.fileObject) {
                let data;
                let file;
                if (this.type === 'application/pdf') {
                    data = await generic.downloadFile({ FileId: this.id }, { responseType: 'blob' });
                    file = new File([data], this.name, { type: 'application/pdf' });
                    this.fileObject = file;
                } else if (this.type === 'image/jpeg' || this.type === 'image/png') {
                    data = await generic.downloadFileAsBase64({ Id: this.id });
                    file = this.base64ToFile(data, this.name);
                    this.fileObject = file;
                } else {
                    this.fileObject = new File([''], this.name, { type: this.type });
                }
            }
        } catch (error) {
            console.error('Error downloading file', error);
        }
    }

    static async create(params) {
        const instance = new QubFile(params);
        await instance.downloadFile();
        return instance;
    }
}

QubFile.propTypes = {
    id: PropTypes.number,
    name: PropTypes.string,
    extension: PropTypes.string,
    type: PropTypes.string,
    file: PropTypes.object,
    position: PropTypes.number,
    fileGuid: PropTypes.string,
    fileObject: PropTypes.object
};

export default QubFile;
